module.exports = [{"id":"jw","name":"Johnnie Walker"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/brands.json
// module id = 579
// module chunks = 0